import React, { FC } from "react";
import Box from "react-raster";
import styled from "styled-components";

const Item = styled.li`
  margin: 0;
  padding: 0;
`;
interface ListProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
  nameId?: string;
  listType?: ListStyle;
  items?: any[];
  key?: string | number | any[]
  label?: any;
  value?: any;
}

type ListStyle = "ol" | "ul";

export const List: FC<ListProps> = ({
  listType = "ul",
  children = [],
  items = [],
}) => {
  return (
    <Box as={listType}
    display="flex"
    flexDirection="column"
    margin="0"
    padding="0"
    list-style="inital"
    >
      {items.map((value, index) => <Item key={index}>{value}</Item>)}
      {React.Children.map(children, (child) => <Item>{child}</Item>)}
    </Box>
  );
};
